module.exports = new __parcel__URL__("wall.34c84631.png").toString();